import { createAction } from 'redux-actions'

export const setAppointmentsCount = createAction('APPOINTMENTS/SET_APPOINTMENTS_COUNT')
